var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('LoadingOverlay',_vm._b({attrs:{"active":_vm.$root.var.loadingOverlay},on:{"update:active":function($event){return _vm.$set(_vm.$root.var, "loadingOverlay", $event)}}},'LoadingOverlay',_vm.LoadingOverlayCnf,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }